import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FNOLInbox.css";

/* ---------- Helper Functions ---------- */
function formatDate(d) {
  return d.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
}

function formatTime(d) {
  return d.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function getDisplayDate(d) {
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const dStr = formatDate(d);
  const nowStr = formatDate(now);
  const yesterdayStr = formatDate(yesterday);

  if (dStr === nowStr) {
    return formatTime(d);
  } else if (dStr === yesterdayStr) {
    return "Yesterday";
  }
  return dStr;
}

/* ---------- Icon Components ---------- */
const IconArrow = ({ open = true }) => (
  <div>
    <svg
      className={`${open ? "rotate-0" : ""}`}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M15 19l-7-7 7-7" />
    </svg>
  </div>
);

/* ---------- FNOL Inbox Component ---------- */
// FNOL Inbox Component
export default function FNOLInbox({
  isOpen,
  onToggle,
  inbox,
  filteredInbox,
  selectedId,
  unreadCount,
  query,
  startDate,
  endDate,
  startTime,
  endTime,
  onQueryChange,
  onStartDateChange,
  onEndDateChange,
  onStartTimeChange,
  onEndTimeChange,
  onResetFilters,
  onItemSelect,
  onToggleRead,
  isSplitScreen,
}) {
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* Collapsed State Button - Visible when closed */}
      {!isSplitScreen && (
        <div
          className={`inbox-toggle-wrapper ${isOpen ? "open" : "closed"}`}
        >
          <button
            className="inbox-toggle-btn"
            onClick={onToggle}
            title="Open Inbox"
            style={{
              backgroundColor: "#006BB3",
              border: "none",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "opacity 0.3s ease",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
            onMouseLeave={(e) => (e.target.style.opacity = "1")}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>
      )}

      {/* Inbox Sidebar Container */}
      <aside
        className={`inbox-sidebar h-100 pb-0 ${isOpen ? "open" : ""}`}
      >
        <div
          className={`card d-flex flex-column desktop-inbox h-100 ${isOpen ? "open" : "closed"
            }`}
          style={{
            backgroundColor: "transparent",
            border: "none",
          }}
        >
          <div
            className="card-header d-flex align-items-center justify-content-between"
            style={{
              backgroundColor: "transparent",
              border: "none",
              flexShrink: 0,
              paddingRight: "10px",
            }}
          >
            <div>
              <h5 className="mb-0 fw-bold">FNOL Inbox</h5>
              <small className="text-primary fw-bold">
                Unread: {unreadCount}
              </small>
            </div>
            <div>
              <button
                className="inbox-toggle-btn"
                onClick={onToggle}
                title="Collapse Inbox"
                style={{
                  backgroundColor: "#006BB3",
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "opacity 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                onMouseLeave={(e) => (e.target.style.opacity = "1")}
              >
                <IconArrow open={true} />
              </button>
            </div>
          </div>

          <div
            className="card-body d-flex flex-column flex-grow-1 overflow-auto"
            style={{
              backgroundColor: "transparent",
              border: "none",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              padding: "2px",
            }}
          >
            <div className="">
              <div className="d-flex mb-2 gap-2 pr-2" style={{ flexShrink: 0 }}>
                <div className="position-relative flex-grow-1">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#006BB3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      position: "absolute",
                      left: "16px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                  >
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                  </svg>
                  <input
                    className="form-control form-control-sm"
                    placeholder="Search FNOL"
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                    style={{
                      borderRadius: "8px",
                      border: "1.5px solid #006BB3",
                      padding: "8px 12px",
                      paddingLeft: "44px",
                    }}
                  />
                </div>
                <button
                  className="btn btn-sm"
                  onClick={() => setShowFilters(!showFilters)}
                  style={{
                    borderRadius: "8px",
                    border: "1.5px solid #006BB3",
                    padding: "4px 8px",
                    backgroundColor: showFilters ? "#006BB3" : "#fff",
                    color: showFilters ? "#fff" : "#006BB3",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.3s ease",
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                  </svg>
                </button>
              </div>

              <div
                style={{
                  maxHeight: showFilters ? "500px" : "0",
                  opacity: showFilters ? 1 : 0,
                  overflow: "hidden",
                  transition:
                    "max-height 0.5s ease-in-out, opacity 0.5s ease-in-out, margin-bottom 0.5s ease",
                  marginBottom: showFilters ? "0.5rem" : "0",
                }}
              >
                <div className="row g-2 mb-2 small" style={{ flexShrink: 0 }}>
                  <div className="col-6">
                    <label className="form-label small fw-bold">Start Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={startDate}
                      onChange={(e) => onStartDateChange(e.target.value)}
                      style={{
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label small fw-bold">End Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={endDate}
                      onChange={(e) => onEndDateChange(e.target.value)}
                      style={{
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    />
                  </div>
                  {/* <div className="col-6">
                    <label className="form-label small fw-bold">Start Time</label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={startTime}
                      onChange={(e) => onStartTimeChange(e.target.value)}
                      style={{
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label small fw-bold">End Time</label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={endTime}
                      onChange={(e) => onEndTimeChange(e.target.value)}
                      style={{
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    />
                  </div> */}
                  <div className="col-12">
                    <button
                      className="btn btn-sm btn-light w-100 fw-bold"
                      onClick={onResetFilters}
                      style={{
                        borderRadius: "8px",
                        padding: "8px 12px",
                        border: "1.5px solid #006BB3",
                        color: "#006BB3",
                      }}
                    >
                      Reset filters
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="flex-grow-1 overflow-auto rounded d-flex flex-column gap-[2px]"
              style={{ border: "none", minHeight: 0 }}
            >
              {filteredInbox.length === 0 ? (
                <div className="text-muted small p-3 fw-bold">
                  No FNOLs found
                </div>
              ) : (
                [...filteredInbox]
                  .sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
                  .map((it) => {
                    const active = it.id === selectedId;
                    const isUnread = !it.read;

                    return (
                      <div
                        key={it.id}
                        className={`inbox-item d-flex align-items-start gap-2 px-3 py-3 cursor-pointer shadow-sm ${active
                          ? "bg-primary bg-opacity-10"
                          : "bg-white"
                          }`}
                        style={{
                          minHeight: "90px",
                          height: "90px",
                          boxShadow: isUnread
                            ? "0 4px 6px rgba(0,0,0,0.1)"
                            : "0 2px 4px rgba(0,0,0,0.05)",
                          borderRadius: "4px",
                          flexShrink: 0,
                          borderLeft: active
                            ? undefined
                            : isUnread
                              ? "4px solid #006BB3"
                              : "4px solid transparent",
                          transition: "all 0.2s ease",
                        }}
                        role="button"
                        onClick={() => {
                          onItemSelect(it);
                          navigate(`/${it.id}/datahandling`);
                          if (window.innerWidth < 992 && isOpen) onToggle();
                        }}
                      >
                        <div className="flex-grow-1 d-flex flex-column justify-content-between h-100">
                          <div className="d-flex justify-content-between">
                            <div
                              className={`${isUnread ? "fw-bold text-muted" : "text-muted"
                                }`}
                            >
                              <div className="d-flex align-items-center">

                                <span
                                  style={{
                                    fontSize: "1.1em",
                                    fontWeight: isUnread ? "700" : "600",
                                    color: "#006BB3",
                                    opacity: 1,
                                  }}
                                >
                                  {it.company}
                                </span>
                              </div>
                              {/* Loss Name */}
                              {it.lossName && (
                                <div
                                  className={`small mt-1 fw-bold ${isUnread ? "text-dark" : "text-muted"
                                    }`}
                                  style={{
                                    fontSize: "0.85em",
                                  }}
                                >
                                  {it.lossName}
                                </div>
                              )}
                            </div>
                            <div
                              className={`small fw-bold text-muted`}
                            >
                              {getDisplayDate(it.datetime)}
                            </div>
                          </div>
                        </div>

                        <div className=" d-flex flex-column align-items-end justify-content-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-muted"
                            style={{ opacity: 0.5 }}
                          >
                            <path d="M9 18l6-6-6-6" />
                          </svg>
                        </div>
                      </div>
                    );
                  })
              )}
            </div>
          </div>

          <div
            className="text-center py-0"
            style={{
              flexShrink: 0,
              backgroundColor: "#fff",
              marginBottom: "5px",
            }}
          >
            <small className="fw-bold" style={{ color: "#006BB3" }}>
              {filteredInbox.length} items
            </small>
          </div>
        </div>
      </aside>
    </>
  );
}